import React from "react";

import RowWrapper from "../../shared/bootstrap/RowWrapper.jsx";
import GeneralInfoLeft from "./GeneralInfoLeft.jsx";
import GeneralInfoRight from "./GeneralInfoRight.jsx";

export default function GeneralInfo({
  displayName,
  companyName,
  corpUrl,
  duns,
  uei,
  tin,
  cage,
  facets,
  ottpFacet,
  certifiedUrl,
  certifiedLogoUrl,
  contracts,
}) {
  return (
    <div className="panel-body">
      <RowWrapper>
        <GeneralInfoLeft
          displayName={displayName}
          companyName={companyName}
          corpUrl={corpUrl}
          duns={duns}
          uei={uei}
          tin={tin}
          cage={cage}
          facets={facets}
          ottpFacet={ottpFacet}
          certifiedUrl={certifiedUrl}
          certifiedLogoUrl={certifiedLogoUrl}
        />
        <GeneralInfoRight contracts={contracts} />
      </RowWrapper>
    </div>
  );
}
